import { createSlice } from '@reduxjs/toolkit';

const routeSlice = createSlice({
  name: 'route',
  initialState: null,
  reducers: {
    setCurrentRoute: (state, action) => action.payload,
  },
});

export const { setCurrentRoute } = routeSlice.actions;
export default routeSlice.reducer;
